export type UserProfileData = {
    exposedUserId: string,
    userDisplayName: string,
    functionalRoles: [],
    language: string,
    personId: number
}

export type UserRequestData = {
    exposedUserId: string,
    functionalRole: string
}

export class UserRequest {

    public static assembleUserRequest(functionalRole: string) : UserRequestData {
        const profile = UserProfile.GetUserProfile()
        return  {
            exposedUserId: profile.exposedUserId,
            functionalRole: functionalRole
        }
    }

}

export class UserProfile {

    private static currentProfile: UserProfileData = {
        exposedUserId: "",
        userDisplayName: "",
        functionalRoles: [],
        language: "de",
        personId: 0
    }

    public static ClearUserProfile() : void { 
        this.currentProfile.exposedUserId = ""
        this.currentProfile.userDisplayName = ""
        this.currentProfile.functionalRoles = []
        this.currentProfile.language = "de"
        this.currentProfile.personId = 0
    }

    public static ChangeUserProfile(exposedUserId: string, personId: number, userDisplayName: string , functionalRoles: []) : void {
        this.currentProfile.exposedUserId = exposedUserId
        this.currentProfile.userDisplayName = userDisplayName
        this.currentProfile.functionalRoles = functionalRoles
        this.currentProfile.personId = personId

    }

    public static GetUserProfile() : UserProfileData {
        return this.currentProfile
    }




    public static IsInFunctionalRoles(functionalRoleName: string) : boolean {
        if (!functionalRoleName) return false 
        if (!this.currentProfile || !this.currentProfile.functionalRoles ) return false

        for(const role of this.currentProfile.functionalRoles) {
            if ( functionalRoleName.indexOf(role) >= 0 ) return true
        }

        return false
    }
}